import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getAvailableStaffAndMachineryCards(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.STAFF_AND_MACHINERY_CARDS,dtConfig[ModulesMap.STAFF_AND_MACHINERY_CARDS].getAvailableStaffAndMachineryCards,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}

function getBasedStaffAndMachineryCards(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.STAFF_AND_MACHINERY_CARDS,dtConfig[ModulesMap.STAFF_AND_MACHINERY_CARDS].getBasedStaffAndMachineryCards,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}

function getExtendedStaffAndMachineryCards(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.STAFF_AND_MACHINERY_CARDS,dtConfig[ModulesMap.STAFF_AND_MACHINERY_CARDS].getExtendedStaffAndMachineryCards,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}

function getFullStaffAndMachineryCards(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.STAFF_AND_MACHINERY_CARDS,dtConfig[ModulesMap.STAFF_AND_MACHINERY_CARDS].getFullStaffAndMachineryCards,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}

export default {
	getAvailableStaffAndMachineryCards,
	getBasedStaffAndMachineryCards,
	getExtendedStaffAndMachineryCards,
	getFullStaffAndMachineryCards,
}
